import {
  displayContractActivityByLocation,
  clearContractActivityChartAction,
  clearContractActivityByLocation,
} from 'actions/charts/contractActivityChartActions'
import React, { useEffect, useState } from 'react'
import { HorizontalBar } from 'react-chartjs-2'
import { useDispatch, useSelector } from 'react-redux'

const ContractActivityChart = ({ contractId }) => {
  //// HOOKS.
  const dispatch = useDispatch()

  //// GLOBAL STATE.
  const { charts, lastAction } = useSelector(
    (state) => state.contractActivityCharts
  )
  const lastActivityAction = useSelector(
    (state) => state.contractActivities.lastAction
  )

  //// LOCAL STATE.
  const [byLocation, setByLocation] = useState({})

  //// LIFECYCLE HELPERS.
  const stringByLocation = charts.byLocation
    ? JSON.stringify(charts.byLocation.data)
    : null

  //// MEMOS.

  //// EFFECTS.
  useEffect(() => {
    if (contractId > 0 && (!stringByLocation || lastActivityAction !== null)) {
      dispatch(displayContractActivityByLocation(contractId))
    }
  }, [dispatch, contractId, stringByLocation, lastActivityAction])

  useEffect(() => {
    return () => {
      dispatch(clearContractActivityByLocation())
    }
  }, [dispatch])

  useEffect(() => {
    if (
      lastAction === 'locationChart' &&
      charts.byLocation &&
      charts.byLocation.data.length
    ) {
      setByLocation({
        labels: charts.byLocation.labels,
        datasets: [
          {
            label: 'Contract Activity By Location',
            data: charts.byLocation.data,
            fill: false,
            backgroundColor: 'rgba(248, 139, 94, 0.5)',
            borderColor: 'rgba(248, 139, 94, 0.75)',
            borderWidth: 1,
          },
        ],
      })
      dispatch(clearContractActivityChartAction())
    }
  }, [lastAction, charts, setByLocation, dispatch])

  //// RENDER VARS & HELPERS.

  //// RENDER.
  return !byLocation || !byLocation.datasets ? (
    <HorizontalBar
      data={byLocation}
      options={{
        scales: {
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Days',
                fontColor: '#2d3848',
                fontSize: 12,
                fontStyle: 'bold',
              },
              ticks: {
                min: 0,
                beginAtZero: true,
              },
            },
          ],
        },
        legend: {
          onClick: (e) => e.preventDefault(),
          align: 'end',
          labels: {
            fontColor: '#ff000',
            fontStyle: 'bold',
            fontSize: 12,
          },
        },
      }}
    />
  ) : (
    ''
  )
}

export default ContractActivityChart
